<template>
  <div
    class="bg-yellow-50 shadow-sm flex flex-col gap-2 px-4 py-3 rounded-lg w-full"
  >
    <div class="flex items-center justify-between w-full">
      <div class="flex items-center gap-2">
        <span
          class="material-symbols-outlined text-[24px]/[24px] text-amber-500"
        >
          draft
        </span>
        <div class="flex items-center gap-1 text-gray-700 whitespace-nowrap">
          <span class="text-sm font-normal">{{ $t('COMMON.NOTE') }}:</span>
          <span class="text-sm font-semibold">{{ senderName }}</span>
        </div>
      </div>
      <div class="flex items-center gap-3">
        <div
          class="flex items-center gap-1 text-xs text-gray-500 whitespace-nowrap"
        >
          <span>{{ relativeDate(messageData.created_at) }}</span>
          <span>{{ hourStamp }}</span>
        </div>
        <slot name="contextMenu" />
      </div>
    </div>
    <div
      v-if="message"
      v-dompurify-html="message"
      class="text-sm text-gray-700 w-full break-words mb-0 private-note-paragraph"
    />
    <email-message-attachments
      v-if="!isNotePending && noteHasAttachments"
      :attachments="attachments"
      :variant="'large'"
      :show-download-icon="true"
    />
  </div>
</template>

<script>
import timeMixin from 'dashboard/mixins/time';
import hidingEmailQuote from './hideEmailQuoteCss';
import { generateBotMessageContent } from '../../../../components/widgets/conversation/helpers/botMessageContentHelper';
import messageFormatterMixin from 'shared/mixins/messageFormatterMixin';
import { MESSAGE_STATUS } from 'shared/constants/messages';

import EmailMessageAttachments from './EmailMessageAttachments.vue';

export default {
  name: 'EmailMessagePrivateNote',
  components: { EmailMessageAttachments },
  mixins: [timeMixin, messageFormatterMixin],
  inject: ['isPending', 'hasAttachments'],
  props: {
    messageData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hidingEmailQuote,
      hasImageError: false,
    };
  },
  computed: {
    attachments() {
      return this.messageData.attachments;
    },
    noteHasAttachments() {
      return !!(
        this.messageData.attachments && this.messageData.attachments.length > 0
      );
    },
    isNotePending() {
      return this.messageData.status === MESSAGE_STATUS.PROGRESS;
    },
    senderName() {
      return this.messageData.sender?.name || '';
    },
    hourStamp() {
      return this.messageStampFull(this.messageData.created_at, 'HH:mm');
    },
    message() {
      const botMessageContent = generateBotMessageContent(
        this.contentType,
        this.contentAttributes,
        {
          noResponseText: this.$t('CONVERSATION.NO_RESPONSE'),
          csat: {
            ratingTitle: this.$t('CONVERSATION.RATING_TITLE'),
            feedbackTitle: this.$t('CONVERSATION.FEEDBACK_TITLE'),
          },
        }
      );

      if (this.contentType === 'input_csat') {
        return this.$t('CONVERSATION.CSAT_REPLY_MESSAGE') + botMessageContent;
      }

      return (
        this.formatMessage(
          this.messageData.content,
          false,
          this.messageData.private,
          false
        ) + botMessageContent
      );
    },
  },
  methods: {
    isAttachmentImageVideoAudio(fileType) {
      return ['image', 'audio', 'video'].includes(fileType);
    },
    onImageLoadError() {
      this.hasImageError = true;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .private-note-paragraph {
    p {
      margin: 0;
    }
  }
}
</style>
